import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function ShippingPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12" data-testid="shipping-page">
      <SEO title="Shipping" description="Australia-wide shipping. Free shipping on orders of 3 or more items." />
      <div className="max-w-[900px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">SUPPORT</p>
          <h1 className="font-heading text-5xl md:text-7xl tracking-tight uppercase leading-[0.9]">
            SHIPPING
          </h1>
          <p className="text-[#A3A3A3] text-lg mt-4">Australia-wide Shipping</p>
        </motion.div>

        <div className="space-y-12 text-[#C0C0C0] text-base leading-relaxed">
          <motion.section initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>Orders are processed within 1–2 business days.</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>Standard shipping times vary depending on your location.</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>You'll receive a tracking number once your order has been dispatched.</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>Shipping costs are calculated automatically during checkout.</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>Free shipping is available on orders of 3 or more items.</span>
              </li>
            </ul>
          </motion.section>

          <motion.section initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
            <p className="text-[#A3A3A3] text-sm">
              For more details, see our <Link to="/returns" className="text-[#FFD700] hover:underline">Returns & Exchanges</Link> and <Link to="/refund-policy" className="text-[#FFD700] hover:underline">Refund Policy</Link>.
            </p>
          </motion.section>
        </div>
      </div>
    </div>
  );
}
